<template>
  <div class="dropdown position-static">
    <button
      class="btn btn-sm btn-primary dropdown-toggle"
      type="button"
      id="dropdownAcoesButton"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Ações
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownAcoesButton">
      <li v-for="(acao, index) in acoes" :key="acao.label + index">
        <router-link
          v-if="acao.nomeRota"
          class="dropdown-item"
          :to="{
            name: acao.nomeRota,
            params: { id: id },
          }"
        >
          {{ acao.label }}
        </router-link>
        <button
          v-else-if="acao.acao"
          @click="acao.acao(item)"
          class="dropdown-item"
        >
          {{ acao.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ActionInterface from "../Tabela/Interface/ActionInterface";

export default defineComponent({
  name: "BotaoAcoes",
  props: {
    acoes: {
      type: Array as PropType<ActionInterface[]>,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
});
</script>
<style scoped>
#app .dropdown-menu button {
  font-size: 1rem !important;
  font-weight: 400 !important;
}
</style>
